import {
  faCheck,
  faChevronDown,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { AccountContext } from "../../components";
import { GrigoraDashboardContext } from "../../components/dashboard/context";
import { PulseLoader } from "react-spinners";
import { APIProviderContext } from "../../components/api";
import DateDisplay from "../../components/ui-kit/date-display";
import { PLANS } from "../../components/plans";
import { ToggleInput } from "../../components/ui-kit";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { Tooltip } from "../../components/input";
import Count from "react-countup";
import { GrigoraAccountContext } from "../../components/grigora-account";
import { toast } from "react-toastify";
import { WhiteLabelContext } from "../../components/whitelabel";

const MONTHLY_PLANS = {
  free: {
    type: "Free",
    price: 0,
    monthlyPrice: 0,
  },
  basic: {
    type: "Basic",
    price: 29,
    monthlyPrice: 29,
  },
  premium: {
    type: "Premium",
    price: 79,
    monthlyPrice: 79,
  },
  enterprise: {
    type: "Enterprise",
    price: 199,
    monthlyPrice: 199,
  },
};

const YEARLY_PLANS = {
  free: {
    type: "Free",
    price: 0,
    yearlyPrice: 0,
  },
  basic: {
    type: "Basic",
    price: 19,
    yearlyPrice: 190,
  },
  premium: {
    type: "Premium",
    price: 49,
    yearlyPrice: 490,
  },
  enterprise: {
    type: "Enterprise",
    price: 179,
    yearlyPrice: 1790,
  },
};

const FEATURES = {
  core: {
    label: "Features",
    features: [
      {
        name: "Drag & Drop Builder",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Drag and drop simplifies moving items by letting you click, hold, and seamlessly place them elsewhere in a single motion.",
      },
      {
        name: "Global CDN",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "A global CDN (Content Delivery Network) optimizes content delivery by distributing it across multiple servers worldwide, ensuring faster loading times and a seamless user experience regardless of geographical location.",
      },
      {
        name: "All Website Blocks",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "Get access to the 55+ blocks available on Grigora.",
      },
      {
        name: "SEO Features",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Using Seo features you can rank your website to the search engines.",
      },
      {
        name: "File Manager",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Grigora has cloud storage to safely store your files and documents.",
      },
      {
        name: "Crawlable Robots.txt",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "Your website will be visible on the internet",
      },
      {
        name: "Google Analytics",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Your can findout the insights of your website using google analytics tools.",
      },
      {
        name: "Google Search Console Connect",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Search Console tools and reports help you measure your site's Search traffic and performance, fix issues, and make your site shine in Google Search results",
      },
      {
        name: "FAQ Schema",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Now it's very easy to add FAQ'S in your blog and website using FAQ block.",
      },
      {
        name: "Custom HTML",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "You can customize your website all the way as you want. Grigora supports Custom HTML, which is used to add your own html code.",
      },
      {
        name: "Auto Optimize Images",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Grigora uses strong image compression algorithms to compress images. These images are available in various dimensions and served to the client according to the bandwidth and requirements.",
      },
      {
        name: "Start from Template",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "No need to start you blog design from scratch. Using pre-built template you can get started with your idea.",
      },
      {
        name: "Embeds",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "Embed social media like twitter, producthunt etc.",
      },
      {
        name: "Google Fonts",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Grigora has Google Fonts supports. So, you can customize your website's font as per business requirement.",
      },
      {
        name: "Basic Website Analytics",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "You will findout the performance and website analytics of your website.",
      },
      {
        name: "Popups",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "Popups are available to trigger call to actions.",
      },
      {
        name: "Animations",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Interactive animations are used to provide good user experience to your customers.",
      },
      {
        name: "HTTPS",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "On Grigora security is the main concern. A secured website can be easily ranked on search engines.",
      },
      {
        name: "Custom Domain",
        free: false,
        basic: true,
        premium: true,
        enterprise: true,
        description: "You have an options to choose your custom domain.",
      },
      {
        name: "Connect To Subdirectory",
        free: false,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Host your website on the subdirectory of your domain. Using this feature you can manager your content effectively.",
      },
      {
        name: "Remove Water Mark",
        free: false,
        basic: true,
        premium: true,
        enterprise: true,
        description: "See the pricing plan to remove watermark.",
      },
    ],
  },
  usage: {
    label: "Usage Limits",
    features: [
      {
        name: "Websites",
        free: "1",
        basic: "1",
        premium: "2",
        enterprise: "5",
        "saaszilla-1": "1",
        "saaszilla-2": "1",
        "saaszilla-3": "10",
        "saaszilla-4": "50",
        "appsumo-1": "1",
        "appsumo-2": "3",
        "appsumo-3": "10",
        "appsumo-4": "50",
        "appsumo-5": "100",
        description: "The number of times your website is viewed.",
      },
      {
        name: "Page Views",
        free: "10k",
        basic: "100k",
        premium: "300k",
        enterprise: "Unlimited",
        "saaszilla-1": "200k",
        "saaszilla-2": "1M",
        "saaszilla-3": "10M",
        "saaszilla-4": "Unlimited",
        "appsumo-1": "200k",
        "appsumo-2": "1M",
        "appsumo-3": "10M",
        "appsumo-4": "Unlimited",
        "appsumo-5": "Unlimited",
        description: "The number of times your website is viewed.",
      },
      {
        name: "Pages",
        free: "5",
        basic: "20",
        premium: "50",
        enterprise: "Unlimited",
        "saaszilla-1": "Unlimited",
        "saaszilla-2": "Unlimited",
        "saaszilla-3": "Unlimited",
        "saaszilla-4": "Unlimited",
        "appsumo-1": "Unlimited",
        "appsumo-2": "Unlimited",
        "appsumo-3": "Unlimited",
        "appsumo-4": "Unlimited",
        "appsumo-5": "Unlimited",
        description:
          "To share more about you business, grigora has the support for pages.",
      },
      {
        name: "Storage",
        free: "2 GB",
        basic: "10 GB",
        premium: "40 GB",
        enterprise: "200 GB",
        "saaszilla-1": "Unlimited",
        "saaszilla-2": "Unlimited",
        "saaszilla-3": "Unlimited",
        "saaszilla-4": "Unlimited",
        "appsumo-1": "Unlimited",
        "appsumo-2": "Unlimited",
        "appsumo-3": "Unlimited",
        "appsumo-4": "Unlimited",
        "appsumo-5": "Unlimited",
        description:
          "A place where you can store your website related files securely.",
      },
      {
        name: "AI Credits",
        free: "15k",
        basic: "15k",
        premium: "40k",
        enterprise: "250k",
        "saaszilla-1": "15k",
        "saaszilla-2": "15k",
        "saaszilla-3": "150k",
        "saaszilla-4": "250k",
        "appsumo-1": "15k",
        "appsumo-2": "30k",
        "appsumo-3": "100k",
        "appsumo-4": "250k",
        "appsumo-5": "1M",
        description: "The number of AI credits you can use.",
      },
      {
        name: "Newsletter Subscribers",
        free: "100",
        basic: "2500",
        premium: "7500",
        enterprise: "25k",
        "saaszilla-1": "15k",
        "saaszilla-2": "15k",
        "saaszilla-3": "150k",
        "saaszilla-4": "250k",
        "appsumo-1": "2.5k",
        "appsumo-2": "10k",
        "appsumo-3": "25k",
        "appsumo-4": "50k",
        "appsumo-5": "200k",
        description: "The number of newsletter subscribers you can have.",
      },
      {
        name: "Webhooks",
        "saaszilla-2": "Unlimited",
        "saaszilla-3": "Unlimited",
        "saaszilla-4": "Unlimited",
        "appsumo-2": "Unlimited",
        "appsumo-3": "Unlimited",
        "appsumo-4": "Unlimited",
        "appsumo-5": "Unlimited",
        description: "The number of webhooks you can have.",
      },
      {
        name: "Team Members",
        free: "1",
        basic: "2",
        premium: "5",
        enterprise: "15",
        "saaszilla-1": "1",
        "saaszilla-2": "3",
        "saaszilla-3": "30",
        "saaszilla-4": "150",
        "appsumo-1": "1",
        "appsumo-2": "3",
        "appsumo-3": "10",
        "appsumo-4": "Unlimited",
        "appsumo-5": "Unlimited",
        description:
          "A place where you can store your website related files securely.",
      },
      {
        name: "Bandwidth",
        free: "5 GB",
        basic: "50 GB",
        premium: "200 GB",
        enterprise: "500 GB",
        "saaszilla-1": "Unlimited",
        "saaszilla-2": "Unlimited",
        "saaszilla-3": "Unlimited",
        "saaszilla-4": "Unlimited",
        description:
          "A good bandwidth helps customer to connect with your business quickly.",
      },
      {
        name: "Form Leads",
        free: "25",
        basic: "2.5k",
        premium: "10k",
        enterprise: "1M",
        "saaszilla-1": "2.5k",
        "saaszilla-2": "10k",
        "saaszilla-3": "Unlimited",
        "saaszilla-4": "Unlimited",
        "appsumo-1": "2500",
        "appsumo-2": "10k",
        "appsumo-3": "Unlimited",
        "appsumo-4": "Unlimited",
        "appsumo-5": "Unlimited",
        description: "Collect the feedback from you customers.",
      },
      {
        name: "File Uploads",
        free: "25 MB",
        basic: "200 MB",
        premium: "1024 MB",
        enterprise: "2048 MB",
        "saaszilla-1": "Unlimited",
        "saaszilla-2": "Unlimited",
        "saaszilla-3": "Unlimited",
        "saaszilla-4": "Unlimited",
        "appsumo-1": "Unlimited",
        "appsumo-2": "Unlimited",
        "appsumo-3": "Unlimited",
        "appsumo-4": "Unlimited",
        "appsumo-5": "Unlimited",
        description: "The size of a file uploaded at a time.",
      },
      {
        name: "Whitelabel",
        "appsumo-4": "Advanced",
        "appsumo-5": "Advanced",
        description: "You can use Grigora as a white label solution.",
      },
    ],
  },
  cms: {
    label: "CMS",
    features: [
      {
        name: "Modern Post Editor",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Grigora has the unique post editor with good user experience and clean UI.",
      },
      {
        name: "SEO Optimization",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Grigora will show you the current strength of you post. You can check the SEO score as well.",
      },
      {
        name: "Save as Draft",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "No sure about you post. No worry, Grigora can save the post in you draft.",
      },
      {
        name: "Schedule Posts",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "Schedule your post to get engaged with your customers.",
      },
      {
        name: "Migration Tools",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "You can migrate your website from other platforms to Grigora. Currently we have the support for Wordpress websites.",
      },
      {
        name: "Sitemap",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "Let the search engine knows about your website.",
      },
      {
        name: "Categories & Tags",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Seperate your posts into Categories and Tags. It will helps you to organized your content.",
      },
      {
        name: "Export & Import",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "Export or Import your posts from excel sheets.",
      },
      {
        name: "Posts",
        free: "50",
        basic: "2000",
        premium: "10000",
        enterprise: "100000",
        description: "Manage all the posts from a single place.",
      },
    ],
  },
  collaboration: {
    label: "Collaboration",
    features: [
      {
        name: "Team Members",
        free: "3",
        basic: "5",
        premium: "15",
        enterprise: "Unlimited",
        description:
          "Let allow others to collaborate on your website. It will help to boost the productivity.",
      },
      {
        name: "Assignments",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "Assign your tasks to the members.",
      },
      {
        name: "Remarks",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description:
          "Grigora has the feature to add remarks on the selected blocks.",
      },
    ],
  },
  support: {
    label: "Support",
    features: [
      {
        name: "Email Support",
        free: true,
        basic: true,
        premium: true,
        enterprise: true,
        description: "We are open to receive your email.",
      },
      {
        name: "Priority Support",
        free: false,
        basic: false,
        premium: true,
        enterprise: true,
        description: "A quick response team that resolves high priority issues",
      },
      {
        name: "Phone Support",
        free: false,
        basic: false,
        premium: false,
        enterprise: true,
        description: "Our customer executive will solve your issue on call.",
      },
      {
        name: "Onboarding Assist",
        free: false,
        basic: false,
        premium: false,
        enterprise: true,
        description: "Grigora will help you to onboard.",
      },
    ],
  },
};

const FeatureCell = ({ feature }) => {
  return (
    <td className="section-row-plan">
      {typeof feature === "boolean" ? (
        feature ? (
          <FontAwesomeIcon icon={faCheck} />
        ) : (
          <></>
        )
      ) : (
        feature
      )}
    </td>
  );
};

const FeatureRow = ({ feature }) => {
  return (
    <tr className="section-row">
      <td className="section-row-feature">
        {feature.name}
        &nbsp; &nbsp;
        <Tooltip
          text={feature?.description}
          overlayStyle={{
            backgroundColor: "#fff",
            opacity: 1,
          }}
          placement="top"
        >
          <FontAwesomeIcon icon={faInfoCircle} color="#5c5c5c" />
        </Tooltip>
      </td>
      {/* <FeatureCell feature={feature.free} /> */}
      <FeatureCell feature={feature.basic} />
      <FeatureCell feature={feature.premium} />
      <FeatureCell feature={feature.enterprise} />
    </tr>
  );
};

const FeatureHeaderCell = ({ feature }) => {
  return <th className="section-header-plan">{feature}</th>;
};

const FeatureHeaderRow = ({ feature, showPlanLabels = false }) => {
  return (
    <tr className="section-header">
      <th className="section-header-category">{feature.label}</th>
      {/* <FeatureHeaderCell feature={showPlanLabels ? "Free": ""} /> */}
      <FeatureHeaderCell feature={showPlanLabels ? "Basic" : ""} />
      <FeatureHeaderCell feature={showPlanLabels ? "Premium" : ""} />
      <FeatureHeaderCell feature={showPlanLabels ? "Enterprise" : ""} />
    </tr>
  );
};

const FeatureSection = ({ feature, showPlanLabels = false }) => {
  return (
    <>
      <FeatureHeaderRow feature={feature} showPlanLabels={showPlanLabels} />
      {feature.features.map((feature, index) => (
        <FeatureRow feature={feature} key={`feature-${feature.name}`} />
      ))}
    </>
  );
};

const List = ({ icon, inverseColor, children }) => {
  return (
    <>
      <p className="mb-1 text-base leading-loose text-body-color ">
        {children ? children : <>&nbsp;</>}
      </p>
    </>
  );
};
const PricingCard = ({
  children,
  description,
  price,
  type,
  subscription,
  buttonText,
  isRecommended = false,
  savings,
  plan,
  monthlyPrice = 0,
  yearlyPrice = 0,
  isYearlyPlan,
  discountPrice,
  showCountUpAnimation = false,
}) => {
  const { isWhitelabel, whitelabelSettings, isWhiteLabelOwner } =
    useContext(WhiteLabelContext) ?? {};

  const { createStripePaymentLink, createLSPaymentLink, apiAction } =
    useContext(APIProviderContext);
  const DashboardContext = useContext(GrigoraDashboardContext);
  const { projectID } = DashboardContext ?? {};
  const [isCreatingPaymentLink, setIsCreatingPaymentLink] = useState(false);

  return (
    <>
      <div className="relative w-full px-4 flex-1 min-w-[300px]">
        {isRecommended && (
          <div className="absolute top-0 left-[50%] translate-x-[-50%] translate-y-[-50%] z-[12] bg-[#623CE7] text-white p-3 py-1 rounded-full text-[14px]">
            Recommended
          </div>
        )}
        <div
          className={classNames(
            "relative z-10 px-8 py-10 mb-10 overflow-hidden border-[2px] text-left rounded-[21px] border-primary border-opacity-20 shadow-pricing sm:p-12 lg:py-8 lg:px-6 xl:p-8 ",
            {
              "!border-ui-blue": isRecommended,
            },
          )}
        >
          <span
            className={`${
              type === "Premium" ? "text-ui-blue" : "text-primary"
            } block mb-4 text-2xl font-semibold `}
          >
            {type}
          </span>
          <p className="text-md text-body-color">{description}</p>

          <h2 className="mb-5 text-[42px] font-bold text-dark">
            {/* <sub className="text-gray-400">
              <s>{price}</s>
            </sub>
            {discountPrice} */}
            {/* {price} */}
            <span>${isYearlyPlan ? yearlyPrice : monthlyPrice}</span>
            <span className="text-base font-medium text-body-color">
              / {subscription}
            </span>
          </h2>
          {savings && (
            <div className="mb-4 text-[14px] text-body-color">
              <span className="text-ui-blue font-semibold">{savings}%</span>{" "}
              Savings
            </div>
          )}
          {/* <p className="text-[#623CE7] text-sm mb-4">
            {isYearlyPlan
              ? "60% off + 30% savings over monthly plans"
              : "60% off"}
          </p> */}
          <button
            onClick={() => {
              if (isCreatingPaymentLink) {
                return;
              }

              if (isWhitelabel && !isWhiteLabelOwner) {
                setIsCreatingPaymentLink(true);
                apiAction(
                  "POST",
                  "user/whitelabel_payments/create_checkout_link",
                  {
                    plan: isYearlyPlan ? `${plan}-yearly` : plan,
                    redirectTo: window.location.href,
                  },
                )
                  .then((data) => {
                    window.open(data.url, "_self");
                    setIsCreatingPaymentLink(false);
                  })
                  .catch((err) => {
                    setIsCreatingPaymentLink(false);
                  });

                return;
              }

              setIsCreatingPaymentLink(true);
              createLSPaymentLink(
                projectID,
                isYearlyPlan ? `${plan}-yearly` : plan,
              )
                .then((data) => {
                  window.open(data.url, "_self");
                  setIsCreatingPaymentLink(false);
                })
                .catch((err) => {
                  setIsCreatingPaymentLink(false);
                });
            }}
            className={`inline-flex border-gray-300 border-[1px] rounded-md font-bold py-3 px-6 text-ui-blue hover:text-white hover:bg-ui-blue transition duration-300 justify-center mt-[10px] md:mt-[0px] gap-2 items-center mb-5 w-full ${
              isRecommended ? "!bg-ui-blue !text-white" : ""
            }`}
          >
            {isCreatingPaymentLink ? (
              <PulseLoader color="gray" size={10} />
            ) : (
              buttonText
            )}
          </button>
          <ul className="mb-0 mx-0">
            <div className="mb-1 text-base leading-loose text-body-color text-left">
              {children}
            </div>
          </ul>
        </div>
      </div>
    </>
  );
};

function InactiveBilling({
  showPricingPlans,
  small = false,
  buttonText = "Start Free Trial",
}) {
  const { isWhitelabel, whitelabelSettings, isWhiteLabelOwner } =
    useContext(WhiteLabelContext) ?? {};

  const [isYearlyPlans, setIsYearlyPlans] = useState(true);
  const [isShowingComparePlans, setIsShowingComparePlans] = useState(true);
  const [showCountUpAnimation, setShowCountUpAnimation] = useState(false);

  const plans = isYearlyPlans ? YEARLY_PLANS : MONTHLY_PLANS;

  var validPlans = whitelabelSettings?.plans?.filter(
    (plan) => !plan?.isArchived,
  );

  return (
    <div>
      <section className="w-full px-4">
        <div className="flex flex-wrap items-center justify-center gap-4 mb-10">
          <div className="flex items-center justify-center gap-2">
            <span
              className={classNames("text-base font-medium text-body-color", {
                "opacity-100": isYearlyPlans,
                "opacity-60": !isYearlyPlans,
              })}
            >
              Pay Annually
            </span>
          </div>
          <div className="rotate-180">
            {/* Toggle Button */}
            <ToggleInput
              sameBGColorAfterToggle={true}
              value={isYearlyPlans}
              onChange={(val) => {
                if (!showCountUpAnimation) {
                  setShowCountUpAnimation(true);
                }
                setIsYearlyPlans(val);
              }}
              className="!mt-0"
            />
          </div>
          <div className="flex items-center justify-center gap-2">
            <span
              className={classNames("text-base font-medium text-body-color", {
                "opacity-100": !isYearlyPlans,
                "opacity-60": isYearlyPlans,
              })}
            >
              Pay Monthly
            </span>
          </div>
        </div>
      </section>
      <section className="flex flex-wrap justify-center -mx-4">
        <div className="flex flex-wrap gap-4">
          {isWhitelabel && !isWhiteLabelOwner ? (
            validPlans?.length > 0 ? (
              validPlans?.map((plan) => (
                <PricingCard
                  key={plan.name}
                  type={plan.planName}
                  price={plan.priceMonthly}
                  plan={plan.planID}
                  subscription={isYearlyPlans ? "year" : "month"}
                  description={plan.planSubtitle}
                  buttonText={buttonText}
                  monthlyPrice={parseInt(plan.priceMonthly)}
                  yearlyPrice={parseInt(plan.priceAnnually)}
                  savings={plan.savings}
                  discountPrice={plan.discountPrice}
                  isYearlyPlan={isYearlyPlans}
                  showCountUpAnimation={showCountUpAnimation}
                >
                  {plan?.features?.map((feature) => (
                    <List icon="check" key={feature}>
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;
                      {feature}
                    </List>
                  ))}
                </PricingCard>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center h-full">
                <p className="italic text-gray-500">
                  No plans found. Please contact support.
                </p>
              </div>
            )
          ) : (
            <>
              <PricingCard
                type="Basic"
                price={plans.basic.price}
                plan={"basic"}
                subscription={isYearlyPlans ? "year" : "month"}
                description="Great for individuals and small businesses with small needs"
                buttonText={buttonText}
                savings={plans.basic.savings}
                discountPrice={plans.basic.discountPrice}
                isYearlyPlan={isYearlyPlans}
                monthlyPrice={plans.basic.monthlyPrice}
                yearlyPrice={plans.basic.yearlyPrice}
                showCountUpAnimation={showCountUpAnimation}
              >
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;1
                  Website
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;200
                  Blog Posts
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;100k
                  Page Views
                </List>
                <List icon="check">
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="#623CE7"
                    className="mt-2"
                  />{" "}
                  &nbsp; 2 Team Members
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;10 GB
                  Storage
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;50 GB
                  Bandwidth
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;2.5k
                  Form Leads
                </List>
                {!small && (
                  <>
                    <List icon="check">
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;Custom Domain
                    </List>
                    <List icon="cancel" inverseColor>
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;Connect to a Directory
                    </List>
                    <List icon="cancel" inverseColor>
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;No watermark
                    </List>
                  </>
                )}
              </PricingCard>
              <PricingCard
                type="Premium"
                price={plans.premium.price}
                subscription={isYearlyPlans ? "year" : "month"}
                description="Perfect for growing businesses or professionals"
                buttonText={buttonText}
                isRecommended={true}
                discountPrice={plans.premium.discountPrice}
                plan={"premium"}
                isYearlyPlan={isYearlyPlans}
                showCountUpAnimation={showCountUpAnimation}
                savings={plans.premium.savings}
                monthlyPrice={plans.premium.monthlyPrice}
                yearlyPrice={plans.premium.yearlyPrice}
              >
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;2
                  Websites
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;1000
                  Blog Posts
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;300k
                  Page Views
                </List>
                <List icon="check">
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="#623CE7"
                    className="mt-2"
                  />{" "}
                  &nbsp; 5 Team Members
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;40 GB
                  Storage
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;200
                  GB Bandwidth
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;10k
                  Form Leads
                </List>
                {!small && (
                  <>
                    <List icon="check">
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;Custom Domain
                    </List>
                    <List icon="cancel" inverseColor>
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;Connect to a Directory
                    </List>

                    <List icon="cancel" inverseColor>
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;No watermark
                    </List>
                  </>
                )}
              </PricingCard>
              <PricingCard
                type="Enterprise"
                price={plans.enterprise.price}
                subscription={isYearlyPlans ? "year" : "month"}
                description="Tailored for large-scale businesses with complex needs"
                buttonText={buttonText}
                discountPrice={plans.enterprise.discountPrice}
                plan={"enterprise"}
                isYearlyPlan={isYearlyPlans}
                showCountUpAnimation={showCountUpAnimation}
                savings={plans.enterprise.savings}
                monthlyPrice={plans.enterprise.monthlyPrice}
                yearlyPrice={plans.enterprise.yearlyPrice}
              >
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;5
                  Websites
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;5000
                  Blog Posts
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;500k
                  Page Views
                </List>
                <List icon="check">
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="#623CE7"
                    className="mt-2"
                  />{" "}
                  &nbsp; 15 Team Members
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;200
                  GB Storage
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;500
                  GB Bandwidth
                </List>
                <List icon="check">
                  <FontAwesomeIcon icon={faCheck} color="#623CE7" /> &nbsp;1M
                  Form Leads
                </List>
                {!small && (
                  <>
                    <List icon="check">
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;Custom Domain
                    </List>
                    <List icon="cancel" inverseColor>
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;Connect to a Directory
                    </List>

                    <List icon="cancel" inverseColor>
                      <FontAwesomeIcon icon={faCheck} color="#623CE7" />{" "}
                      &nbsp;No watermark
                    </List>
                  </>
                )}
              </PricingCard>
            </>
          )}
        </div>
      </section>
      {/* Compare Plans */}
      {showPricingPlans && !isWhitelabel && (
        <section className="pricing-comparison w-full px-4 ">
          {/* <h2
                        className='text-center font-bold text-[32px] md:text-[40px] mb-10'
                    >Compare Plans
                        
                    </h2> */}
          <button
            onClick={(e) => {
              setIsShowingComparePlans(!isShowingComparePlans);
            }}
            className="bg-white text-inherit text-left cursor-pointer mb-10 flex mx-auto items-center px-6 py-5 gap-[15px]"
          >
            <h2 className="text-[32px] md:text-[40px] mb-0 font-bold">
              Compare Plans
            </h2>
            <div
              className="w-[30px] h-[30px] flex justify-center items-center duration-200"
              style={{
                rotate: isShowingComparePlans ? "180deg" : "0deg",
              }}
            >
              <FontAwesomeIcon
                icon={faChevronDown}
                className="text-[black] text-[20px]"
              />
            </div>
          </button>
          {isShowingComparePlans && (
            <table>
              <tbody>
                <FeatureSection feature={FEATURES.core} showPlanLabels={true} />
                <FeatureSection feature={FEATURES.usage} />
                <FeatureSection feature={FEATURES.cms} />
                <FeatureSection feature={FEATURES.support} />
              </tbody>
            </table>
          )}
        </section>
      )}
    </div>
  );
}

function ActiveBilling() {
  const [isLoading, setIsLoading] = useState(false);
  const DashboardContext = useContext(GrigoraDashboardContext) ?? {};
  const { projectID, project, setProjectData } = DashboardContext;
  const {
    getSubscription,
    cancelProjectSubscription,
    manageSubscription,
    manageLSSubscription,
    apiAction,
  } = useContext(APIProviderContext);
  const { userAttributes } = useContext(AccountContext);

  const [subscriptionDetails, setSubscriptionDetails] = useState();

  const [isCancellingSubscription, setIsCancellingSubscription] =
    useState(false);

  const { userData } = useContext(GrigoraAccountContext);

  var plan;

  plan =
    DashboardContext?.subscriptionPlan ??
    userData?.subscription?.plan ??
    "basic";

  var subscription = userData?.subscription;

  const { isWhitelabel, whitelabelSettings, isWhiteLabelOwner } =
    useContext(WhiteLabelContext) ?? {};

  var whiteLabelPlan;

  if (isWhitelabel && !isWhiteLabelOwner) {
    whiteLabelPlan = whitelabelSettings?.plans?.find(
      (singlePlan) => singlePlan.planID === plan,
    );
  }

  // useEffect(() => {
  //   setIsLoading(true);
  //   getSubscription(projectID)
  //     .then((data) => {
  //       setIsLoading(false);
  //       setSubscriptionDetails(data);
  //       console.log(data);
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       console.log(err);
  //     });
  // }, []);

  // var currentPeriodStart = new Date(
  //   (subscriptionDetails?.subscription?.current_period_start ||
  //     subscriptionDetails?.subscription?.created_at) * 1000,
  // );
  // var currentPeriodEnd = new Date(
  //   subscriptionDetails?.subscription?.current_period_end * 1000,
  // );

  var usageLimits = FEATURES?.usage?.features
    ?.map((feature) => {
      if (feature?.[plan]) {
        return feature?.[plan] + " " + feature?.name;
      }
      return null;
    })
    .filter((item) => item !== null);

  if (isLoading) {
    return (
      <>
        <PulseLoader size={8} />
      </>
    );
  }

  // var plan = subscriptionDetails?.grigoraData?.plan;

  return (
    <div className="flex flex-row justify-between items-center w-full rounded-[21px] text-grigora-base">
      <div className="max-w-full w-[660px]">
        <h1 className="text-[28px] w-11/12 font-[500]">Current Plan</h1>
        <p className="text-grigora-base my-4 w-7/12">
          Your Subscription details:
        </p>
        <div className="">
          <div className="flex flex-col justify-between items-center gap-3 bg-ui-light-white rounded-[21px] px-[30px] py-[26px]">
            <div className="w-full flex flex-row justify-center items-center gap-3 mb-4">
              <div className="flex flex-col gap-2">
                <h6 className="text-black text-[16px] text-center font-semibold">
                  <span className="capitalize">
                    {isWhitelabel && !isWhiteLabelOwner
                      ? whiteLabelPlan?.planName
                      : plan}
                  </span>{" "}
                  Plan
                </h6>

                {/* <p className="text-grigora-base">
                <span className="text-[24px]">
                  ${subscriptionDetails?.subscription?.plan?.amount / 100}
                </span>
                <span className="text-[16px]">/mo</span>
              </p> */}
              </div>
            </div>
            <div className="w-full flex flex-col gap-2 items-center">
              {whiteLabelPlan?.features?.map((feature) => {
                return (
                  <p
                    key={`usage-limit-${feature}`}
                    className="text-grigora-base"
                  >
                    {feature}
                  </p>
                );
              })}
              {usageLimits?.map((limit) => {
                return (
                  <p key={`usage-limit-${limit}`} className="text-grigora-base">
                    {limit}
                  </p>
                );
              })}
            </div>
            <div className="w-full mt-2 text-center">
              <button
                onClick={() => {
                  if (isWhitelabel && !isWhiteLabelOwner) {
                    apiAction(
                      "POST",
                      `user/whitelabel_payments/manage_subscription`,
                      {
                        redirectTo: window.location.href,
                      },
                    )
                      .then((data) => {
                        if (data?.url) {
                          window.open(data.url, "_blank");
                        }
                      })
                      .catch((err) => {
                        toast.error(err?.message ?? "Something went wrong");
                      });

                    return;
                  }

                  if (subscription?.platform === "appsumo") {
                    window.open(
                      "https://appsumo.com/account/products/",
                      "_blank",
                    );
                    return;
                  }

                  if (subscription?.platform === "saaszilla") {
                    toast.info(
                      "You are using a Saaszilla license. Please contact support to manage your subscription.",
                    );
                    return;
                  }

                  if (subscription?.platform === "lemonsqueezy") {
                    manageLSSubscription()
                      .then((data) => {
                        if (data?.link) {
                          window.open(data.link);
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    return;
                  }

                  manageSubscription(projectID)
                    .then((data) => {
                      if (data?.link) {
                        window.open(data.link, "_blank");
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }}
                className="grigora-action-btn"
              >
                {isCancellingSubscription ? (
                  <>
                    <PulseLoader color="#ffffff" size={8} />
                  </>
                ) : (
                  <>Manage Subscription</>
                )}
              </button>
            </div>
          </div>
          {/* <div className="flex flex-row gap-[30px] mt-[19px]">
            <div className="flex flex-row flex-1 justify-between items-center gap-3 bg-ui-light-white rounded-[21px] px-[30px] py-[26px]">
              <div className="flex flex-col gap-2">
                <h6 className="">Last Payment Made On</h6>
                <p className="text-grigora-base">
                  <DateDisplay date={currentPeriodStart} />
                </p>
              </div>
            </div>
            <div className="flex flex-row flex-1 justify-between items-center gap-3 bg-ui-light-white rounded-[21px] px-[30px] py-[26px]">
              <div className="flex flex-col gap-2">
                <h6 className="">Subscription Renews on</h6>
                <p className="text-grigora-base">
                  {subscriptionDetails?.subscription?.cancel_at_period_end ? (
                    <>
                      Cancelled. Subscription valid till{" "}
                      <DateDisplay date={currentPeriodEnd} />
                    </>
                  ) : (
                    <>
                      <DateDisplay date={currentPeriodEnd} />
                    </>
                  )}
                </p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

function Billing({
  showPricingPlans = true,
  buttonText = "Start Free Trial",
  small = false,
}) {
  const isProjectSubscribed = useContext(GrigoraDashboardContext)?.isSubscribed;
  const isUserSubscribed = useContext(GrigoraAccountContext)?.isSubscribed;

  var isSubscribed = isProjectSubscribed || isUserSubscribed;

  return (
    <>
      {isSubscribed ? (
        <>
          <ActiveBilling />
        </>
      ) : (
        <>
          <InactiveBilling
            small={small}
            showPricingPlans={showPricingPlans}
            buttonText={buttonText}
          />
        </>
      )}
    </>
  );
}

export default Billing;
